import { CellProps, GroupUsersComponent } from './GroupUsers.types';
import { RichTable } from '../../../../common';
import { TableData } from '@hiiretail/synergy-ui/dist/types/components/surfaces/Table/Table.types';
import { useMemo } from 'react';
import { GroupUsersWrapper } from './GroupUsers.styles';
import { UserDto } from '../../../../api-client';
import { RowActions } from '../../../../common/components/RowActions/RowActions';
import { Icon } from '@hiiretail/synergy-ui';
import { Status } from '../../../../common/components/Status/Status';

type UserTableData = TableData & UserDto;

export const GroupUsers: GroupUsersComponent = ({
  users,
  isLoading,
  fetchError,
  refetchGroupUsers,
  onAddButtonClick,
  setGroupUserToDelete,
  onUserClick,
}) => {
  const tableColumns = useMemo(
    () => [
      { Header: 'Name', accessor: 'name' },
      { Header: 'Type', accessor: 'type' },
      {
        Header: 'Status',
        accessor: 'status',
        Cell: ({ row: { original } }: CellProps<UserDto>) => (
          <Status status={original.status} variant="body2" />
        ),
      },
      {
        Header: 'Actions',
        Cell: ({ row: { original } }: CellProps<UserDto>) => (
          <RowActions
            original={original}
            setItemToUpdate={() => void 0}
            toggleUpdateItemModal={() => void 0}
            onUpdateButtonClick={() => setGroupUserToDelete(original)}
            disabled={false}
          >
            <Icon.Delete />
          </RowActions>
        ),
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  return (
    <GroupUsersWrapper container item>
      <RichTable
        id="group-users"
        title="Group members"
        columns={tableColumns}
        data={users as UserTableData[]}
        isLoading={isLoading}
        fetchError={fetchError}
        refetch={refetchGroupUsers}
        errorSubject="group members"
        searchFieldLabel=""
        onSearchChange={() => void 0}
        permissions={{
          list: 'iam.group.list-users',
          create: 'iam.group.update',
        }}
        onRowClick={onUserClick}
        hideSearch
        createButtonTitle="Add member"
        onCreateButtonClick={onAddButtonClick}
        createButtonPermission="iam.user.assign-group"
      />
    </GroupUsersWrapper>
  );
};
